import './App.css';

import { Routes, Route } from "react-router-dom";
import Home from './components/home/home';
import FAQ from './components/faq/faq';
import Layout from './components/layout/layout';
import Recommended from './components/recommended/recommended';
import Prepare from './components/prepare/prepare';
import TermsOfUse from './components/terms-of-use/terms-of-use';
import PrivacyPolicy from './components/privacy-policy/privacy-policy';

function App() {
  return (
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Prepare />} />
          <Route path="faq" element={<FAQ />} />
          <Route path="/:culture/faq" element={<FAQ />} />
          <Route path="/:culture/:location/faq" element={<FAQ />} />
          <Route path="bkcapp" element={<Home />} />
          <Route path="/:culture/bkcapp" element={<Home />} />
          <Route path="/:culture/:location/bkcapp" element={<Home />} />
          <Route path="recommended" element={<Recommended />} />
          <Route path="/:culture/recommended" element={<Recommended />} />
          <Route path="/:culture/:location/recommended" element={<Recommended />} />
          <Route path="/:culture/*" element={<Prepare />} />
          <Route path="/:culture/:location/*" element={<Prepare />} />
          <Route path="*" element={<Prepare />} />
          <Route path="terms-of-use" element={<TermsOfUse />} />
          <Route path="/:culture/terms-of-use" element={<TermsOfUse />} />
          <Route path="/:culture/:location/terms-of-use" element={<TermsOfUse />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/:culture/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/:culture/:location/privacy-policy" element={<PrivacyPolicy />} />
        </Route>
      </Routes>
  );
}

export default App;
